import { render } from "./FormIsolatieplanCheckView.vue?vue&type=template&id=efee5ff0"
import script from "./FormIsolatieplanCheckView.vue?vue&type=script&lang=js"
export * from "./FormIsolatieplanCheckView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__